import { DayOfWeek, PeriodicEmailFrequency } from "../components/periodic-email-settings/common";

export interface IPeriodicEmailSettings {
    SendPeriodicEmail: boolean,
    IncludeOnlyNew: boolean,
    Frequency: PeriodicEmailFrequency,
    Weekdays: DayOfWeek[],
    Times: string[]
}

export const DefaultTimeString: string = "12:00"

export function createDefaultPeriodicEmailSettings(): IPeriodicEmailSettings {
    return <IPeriodicEmailSettings> {
        SendPeriodicEmail: false,
        IncludeOnlyNew: false,
        Frequency: PeriodicEmailFrequency.OnceDaily,
        Weekdays: [],
        Times: [DefaultTimeString]
    }
}

export function isPartiallyInitialized(pes: IPeriodicEmailSettings): boolean {
    return !pes.Frequency || !pes.Weekdays || !pes.Times
}